import { CircleAlert } from "lucide-react";

interface InlineErrorProps {
  message?: string | null;
  className?: string;
}

export default function InlineError({
  message,
  className = "",
}: InlineErrorProps) {
  if (!message) return null;

  return (
    <div
      className={`flex items-start gap-2 self-stretch -mt-2 ${className}`}
    >
      <CircleAlert className="h-4 w-4 text-[#DC2626] flex-shrink-0" />
      <p className="text-xs leading-4 font-normal text-[#DC2626] flex-1">
        {message}
      </p>
    </div>
  );
}
